import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  createFetchAction,
  createSaga,
  fetchInitialState,
  fetchReducerActions,
  uploadFileProgress,
} from 'store/utils';
import { BASE_API_URL } from 'lib/setting';
import { AppActions, BinActions, FileActions, ProjectActions } from 'store/actionCreators';
import * as fileApi from 'api/file';
import * as projectApi from 'api/project';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import store from 'store';
import { projectEventType } from 'lib/mapper';
import { AxiosResponse } from 'axios';

export const fetch_project_files = createFetchAction('fetch_project_files');
export const upload_project_file = createFetchAction('upload_project_file');
export const delete_project_file = createFetchAction('delete_project_file');
export const complete_project_file_upload = createFetchAction('complete_project_file_upload');
export const edit_project_share = createFetchAction('edit_project_share');
export const fetch_employee_image_upload = createFetchAction('fetch_employee_image_upload');
export const delete_employee_image = createFetchAction('delete_employee_image');
export const fetch_partner_image_upload = createFetchAction('fetch_partner_image_upload');
export const delete_partner_image = createFetchAction('delete_partner_image');
export const complete_image_file_upload = createFetchAction('complete_image_file_upload');
export const fetch_qna_file_upload = createFetchAction('fetch_qna_file_upload');
export const fetch_cloud_project_list = createFetchAction('fetch_cloud_project_list');
export const delete_cloud_projects = createFetchAction('delete_cloud_projects');
export const delete_cloud_projects_period = createFetchAction('delete_cloud_projects_period');

interface InnitialState {
  projectSyncCloudData: object | any;
  projectFiles:
    | {
        data: {
          fileData: {
            groupFileList: any[];
            partnerFileList: any[];
          };
        };
      }
    | any;
  uploadProjectFile: object | any;
  deleteProjectFile: object | any;
  completeProjectFileUpload: object | any;
  editProjectShare: object | any;
  employeeImageUploadUrl: object | any;
  deleteEmployeeImage: object | any;
  partnerImageUploadUrl: object | any;
  deletePartnerImage: object | any;
  completeImageFileUpload: object | any;
  qnaFileUploadUrl: object | any;
  cloudProjectList: object | any;
  deleteCloudProjects: object | any;
  deleteCloudProjectsPeriod: object | any;
  isFullScreen: boolean | any;
}

const initialState: InnitialState = {
  projectSyncCloudData: null,
  projectFiles: { ...fetchInitialState, data: null },
  uploadProjectFile: { ...fetchInitialState },
  deleteProjectFile: { ...fetchInitialState },
  completeProjectFileUpload: { ...fetchInitialState },
  editProjectShare: { ...fetchInitialState },
  employeeImageUploadUrl: { ...fetchInitialState },
  deleteEmployeeImage: { ...fetchInitialState },
  partnerImageUploadUrl: { ...fetchInitialState },
  deletePartnerImage: { ...fetchInitialState },
  completeImageFileUpload: { ...fetchInitialState },
  qnaFileUploadUrl: { ...fetchInitialState },
  cloudProjectList: { ...fetchInitialState },
  deleteCloudProjects: { ...fetchInitialState },
  deleteCloudProjectsPeriod: { ...fetchInitialState },
  isFullScreen: false,
};

const slice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    set_project_sync_cloudData: (state: any, { payload }: PayloadAction<any>) => {
      state.projectSyncCloudData = payload;
    },
    set_project_files: (state: any, { payload }: PayloadAction<any>) => {
      console.log('set_project_files ____ ');
      state.projectFiles.data = payload;
    },
    ...fetchReducerActions(fetch_project_files, 'projectFiles', {
      success(state: any, { payload }: PayloadAction<any>) {
        console.log('file projectFiles payload', payload);
      },
    }),
    ...fetchReducerActions(upload_project_file, 'uploadProjectFile'),
    ...fetchReducerActions(delete_project_file, 'deleteProjectFile'),
    ...fetchReducerActions(complete_project_file_upload, 'completeProjectFileUpload'),
    ...fetchReducerActions(edit_project_share, 'editProjectShare'),
    ...fetchReducerActions(fetch_employee_image_upload, 'employeeImageUploadUrl'),
    ...fetchReducerActions(delete_employee_image, 'deleteEmployeeImage'),
    ...fetchReducerActions(fetch_partner_image_upload, 'partnerImageUploadUrl'),
    ...fetchReducerActions(delete_partner_image, 'deletePartnerImage'),
    ...fetchReducerActions(complete_image_file_upload, 'completeImageFileUpload'),
    ...fetchReducerActions(fetch_qna_file_upload, 'qnaFileUploadUrl'),
    ...fetchReducerActions(fetch_cloud_project_list, 'cloudProjectList'),
    ...fetchReducerActions(delete_cloud_projects, 'deleteCloudProjects'),
    ...fetchReducerActions(delete_cloud_projects_period, 'deleteCloudProjectsPeriod'),
    set_is_full_screen: (state: any, { payload }: any) => {
      state.isFullScreen = payload;
    },
  },
});

export const actions: any = slice.actions;

// export async function requestApi(request: Promise<any>) {
//   try {
//     const response = await request;
//     return response.data;
//     // return [response.data, null];
//   } catch (error) {
//     AppActions.show_toast({ type: 'error', message: (error as { message: string })?.message });
//     // return [null, error]
//   }
// }

// createSaga
function* handleUploadProjectFile({ payload }: any) {
  const {
    company,
    projectCode,
    project: files,
    isShare = 1,
    syncPartnerId,
    projectId,
    type,
  } = payload;
  const fileGroupId = moment().unix() + uuid();
  console.log('handleUploadProjectFile payload----------------------------------', payload);
  // console.log('fileGroupId', fileGroupId);

  if (!files?.length) return;
  try {
    let filesContent = '';
    let cloudDataList: number[] | any = [];

    // 성공 후 파일 로드 시점issue로 인해 await 이후 실행
    const excuteAfterResponse = (filesContent: string, isLast: boolean) => {
      const createHistoryData = {
        projectCode,
        type: projectEventType.fileUpload,
        shareType: isShare, // 1: Group, 2: Partner
        params: {
          content: `${company}${filesContent}`,
        },
      };

      // socket.projectUpdate 변경
      // FileActions.fetch_project_files_request(projectCode);
      if (!isLast) return;
      console.log('isLast ______ ', isLast);
      console.log('filesContent ______ ', filesContent);

      ProjectActions.create_project_history_request(createHistoryData);
    };

    const promiseFile = files.map(async (item: any, idx: number) => {
      console.log('item', item);
      const formPayload: any = new FormData();
      // formPayload.append('project', item.file);
      const isLast = idx === files.length - 1;
      // console.log('isLast _______ ', isLast);
      const progressId = uuid();

      const uploadData = {
        projectCode,
        fileGroupId,
        fileName: item.file.name,
        fileSize: item.file.size,
        isShare,
      };
      // TEST:
      // if (idx === 0) {
      //   uploadData.fileName = null;
      // }

      console.log('HDS1] uploadData _______ ', uploadData);

      // const data = requestApi(fileApi.fetchProjectFileUploadUrl(uploadData));
      let projectFileUploadUrlData = null;
      try {
        const response = await fileApi.fetchProjectFileUploadUrl(uploadData);
        console.log('projectFileUploadUrlData data', response.data);
        if (response.data.status === 200) FileActions.fetch_project_files_request(projectCode);
        projectFileUploadUrlData = response.data;

        // data = responseData;
      } catch (error) {
        const errorData = error as { message: string; response: any };
        const message = errorData?.response?.data?.msg || errorData.message;
        const status = errorData?.response?.status;
        AppActions.add_upload_file_progress({
          id: progressId,
          file: item.file,
          progress: 0,
          status: 0,
          error: { status, message },
          projectCode,
          projectId,
          type,
        });
      }

      if (!projectFileUploadUrlData) return;
      const { signedUrl, cloudDataIdx } = projectFileUploadUrlData;

      if (typeof signedUrl === 'string') {
        await uploadFileProgress({
          projectCode,
          projectId,
          type,
          id: progressId,
          file: item.file,
          url: signedUrl,
          method: 'put',
          async success() {
            // BinActions.upload_project_file_success();
            console.log('handleUploadProjectFile success');
            cloudDataList = [...cloudDataList, cloudDataIdx];
            filesContent = filesContent + `, ${item.file?.name}`;
            await fileApi.completeProjectFileUpload({
              fileType: 'project',
              data: {
                duplicateCloudDataIdx: item.cloudDataIdx,
                cloudDataIdx,
                isSuccess: 1,
              },
            });

            FileActions.upload_project_file_success(item.file?.name);

            // if (isLast) {
            //   if (syncPartnerId) {
            //     console.log('reqiest createProjectSync');
            //     console.log('cloudDataList', cloudDataList);
            //     try {
            //       await projectApi.createProjectSync({
            //         projectCode,
            //         partnerGroupIdx: syncPartnerId,
            //         cloudDataList,
            //       });
            //       // api호출 후 store 성공으로 변경
            //       ProjectActions.create_project_sync_success();
            //     } catch (error) {
            //       AppActions.show_toast({
            //         type: 'error',
            //         message: (error as { message: string })?.message,
            //       });
            //     }
            //   }
            //   // TODO: reFetch 수정하기
            // }
          },
          async failure() {
            console.log('handleUploadProjectFile failure');
            await fileApi.completeProjectFileUpload({
              fileType: 'project',
              data: {
                duplicateCloudDataIdx: item.cloudDataIdx,
                cloudDataIdx,
                isSuccess: 0,
              },
            });
            // if (isLast) {
            //   excuteAfterResponse(item);
            // }
          },
          finish() {
            console.log('handleUploadProjectFile finish');
          },
        });
      }
    });

    const projectPartnerSync = async (
      projectCode: string,
      syncPartnerId: number | undefined,
      cloudDataList: any[],
    ) => {
      console.log('HDS1] projectSync ____________ ', syncPartnerId, '_______ ', !!syncPartnerId);
      if (!syncPartnerId) return;
      // await projectApi.createProjectSync({
      //   projectCode,
      //   partnerGroupIdx: syncPartnerId,
      //   cloudDataList,
      // });
      try {
        await projectApi.createProjectSync({
          projectCode,
          partnerGroupIdx: syncPartnerId,
          cloudDataList,
        });
      } catch (error) {
        AppActions.show_toast({
          type: 'error',
          message: (error as { message: string })?.message,
        });
      }
    };
    yield Promise.all(promiseFile);
    yield projectPartnerSync(projectCode, syncPartnerId, cloudDataList);
    yield put(ProjectActions.create_project_sync_success());
    yield put(ProjectActions.fetch_project_request(projectCode));
    yield excuteAfterResponse(filesContent, true);
  } catch (error) {
    // console.log(error);
    AppActions.show_toast({ type: 'error', message: (error as { message: string })?.message });
  }
}

// function* handleEditPortfolioFile({ payload }) {
//   const { deletePortfolio, portfolio: files, userCode } = payload;
//   console.log('handleEditPortfolioFile payload', payload);

//   if (files.length) {
//     files.forEach(async file => {
//       const formPayload = new FormData();
//       formPayload.append('deletePortfolio', deletePortfolio);
//       formPayload.append('portfolio', file);

//       uploadFileProgress({
//         file,
//         url: `${BASE_BIN_URL}/portfolio`,
//         formPayload,
//         config: {
//           headers: {
//             'x-access-token': store.getState().auth.accessToken,
//           },
//         },
//         success() {
//           BinActions.upload_project_file_success();
//         },
//         finish() {
//           ProjectActions.fetch_portfolio_request({ userCode });
//         },
//       });
//     });
//   }
// }

export function* fileSaga() {
  yield all([
    takeLatest(
      actions.fetch_project_files_request,
      createSaga(actions, 'fetch_project_files', fileApi.fetchProjectFiles),
    ),
    takeLatest(actions.upload_project_file_request, handleUploadProjectFile),
    takeLatest(
      actions.delete_project_file_request,
      createSaga(actions, 'delete_project_file', fileApi.deleteProjectFile),
    ),
    takeLatest(
      actions.complete_project_file_upload_request,
      createSaga(actions, 'complete_project_file_upload', fileApi.completeProjectFileUpload),
    ),
    takeLatest(
      actions.edit_project_share_request,
      createSaga(actions, 'edit_project_share', fileApi.editProjectShare),
    ),
    takeLatest(
      actions.fetch_employee_image_upload_request,
      createSaga(actions, 'fetch_employee_image_upload', fileApi.fetchEmployeeImageFileUploadUrl),
    ),
    takeLatest(
      actions.delete_employee_image_request,
      createSaga(actions, 'delete_employee_image', fileApi.deleteEmployeeImageFile),
    ),
    takeLatest(
      actions.fetch_partner_image_upload_request,
      createSaga(actions, 'fetch_partner_image_upload', fileApi.fetchPartnerImageFileUploadUrl),
    ),
    takeLatest(
      actions.delete_partner_image_request,
      createSaga(actions, 'delete_partner_image', fileApi.deletePartnermageFile),
    ),
    takeLatest(
      actions.complete_image_file_upload_request,
      createSaga(actions, 'complete_image_file_upload', fileApi.completeImageFileUpload),
    ),
    takeLatest(
      actions.fetch_qna_file_upload_request,
      createSaga(actions, 'fetch_qna_file_upload', fileApi.fetchQnaFileUploadUrl),
    ),
    takeLatest(
      actions.fetch_cloud_project_list_request,
      createSaga(actions, 'fetch_cloud_project_list', fileApi.fetchCloudProjectList),
    ),
    takeLatest(
      actions.delete_cloud_projects_request,
      createSaga(actions, 'delete_cloud_projects', fileApi.deleteCloudProjects),
    ),
    takeLatest(
      actions.delete_cloud_projects_period_request,
      createSaga(actions, 'delete_cloud_projects_period', fileApi.deleteCloudProjectByPeriod),
    ),
  ]);
}

export default slice.reducer;

// config: {
//   headers: {
//     'Content-Type': 'multipart/form-data',
//   },
// },
// formPayload,
// config: {
//   headers: {
//     'x-access-token': store.getState().auth.accessToken,
//     projectCode,
//     cloudDataIdx: item.cloudDataIdx,
//   },
// },
